import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Messages.css';

// Query
import messagesQuery from './messagesQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import Loader from '../../../components/Loader';

import MessageManagement from '../../../components/siteadmin/MessageManagement';

class Messages extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getAllMessageHistory: PropTypes.array,
    })
  };

  render() {

    const { messageManagement: { loading, messageManagement } } = this.props;

    if (loading) {
      return <Loader type={"text"} />;
    } else {
      return <MessageManagement
        messageManagement={messageManagement}
      // refetch={refetch} 
      />
    }
  }

}

export default compose(
  withStyles(s),
  withQuery(messagesQuery, {
    name: 'messageManagement',
    options: {
      variables: {
        currentPage: 1,
        searchList: ''
      },
      fetchPolicy: 'network-only',
      ssr: false
    }
  })
)(Messages);
